import React from "react";
import "./UserLogin.css";
import { useState, useRef } from "react";
import { Link, useParams,useHistory} from "react-router-dom";
import { useUserAuth } from "../context/UserAuthContext";
export default function UserLogin() {
  const historyUser = useHistory()
  const btn = useRef();
  const [active, setActive] = useState(false);
  const { user, logOut,setLogoutInfo } = useUserAuth();
  const handleLogin = (e) => {
    setActive(!active);
    btn.current.classList.toggle("login-user-active");
  };

  const handleLogout = async () => {
    try {
      await logOut();
      historyUser.push("/")
      setLogoutInfo(true)
    } catch (err) {
      console.log(err.message);
    }
  };
  return (
    <button
      className={`login-user ${active ? "btn-show" : ""}`}
      style={{ border: "none" }}
      onClick={handleLogin}
    >
      <i
        style={{
          marginRight: "10px",
          fontSize: "16px",
          color: "rgb(81, 97, 109)",
        }}
        className="fa-solid fa-circle-user"
      ></i>
      <i
        style={{ fontSize: "14px", color: "rgb(81, 97, 109)" }}
        className="fa-solid fa-caret-down"
      ></i>
      <div
        className={"login-user-btn"}
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          alignItems: "flex-start",
          padding: "5px",
          color: "rgb(81, 97, 109)",
          padding: "10px",
        }}
        // onClick={(e)=>e.stopPropagation()}
        ref={btn}
      >
        <h4>
          Username :
          {(
            <UserLightLight
              user={`${" " + user?.email?.substring(0, user.email.lastIndexOf("@"))}`}
            />
          )}
        </h4>
        <p>Credit Balance: 0$</p>
        <div>
          <p>
            Details : <span style={{ color: "#2ed573" }}>Basic User</span>
          </p>
          {/* <span>Buy Credits or Subscribe</span> */}
        </div>
        <Link style={{ color: "rgb(81, 97, 109)" }} to="/dashboard">
          <p className="dashboard-user">
            <i
              style={{ marginRight: "5px" }}
              className="fa-solid fa-gauge-high"
            ></i>
            My Dashboard
          </p>
        </Link>
        <p
          className="dashboard-user"
          style={
            {
              // padding: "3px",
            }
          }
          onClick={handleLogout}
        >
          <i
            style={{ marginRight: "5px" }}
            className="fa-solid fa-arrow-right-from-bracket"
          ></i>
          Logout
        </p>
      </div>
    </button>
  );
}
// ${active ? "login-user-active" : ""}
const UserLightLight = ({ user }) => {
  return <span style={{ color: "#2ed573" }}>{user}</span>;
};
